import React, { useEffect, useState } from "react";

export const StickyCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = document.getElementById("hero");
    if (!hero) return;
    if (!("IntersectionObserver" in window)) {
      setVisible(true);
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting),
      { threshold: 0, rootMargin: "-40px 0px 0px 0px" }
    );
    io.observe(hero);
    return () => io.disconnect();
  }, []);

  const onClick = (e) => {
    e.preventDefault();
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <a
      href="#contact"
      onClick={onClick}
      data-testid="sticky-cta"
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
      className={`fixed z-40 inline-flex items-center gap-2 h-12 px-6 rounded-full font-body text-[12px] tracking-[0.18em] uppercase shadow-lg transition-all duration-500 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      style={{
        backgroundColor: "#3a7d7b",
        color: "#f4f1eb",
        right: "max(1rem, env(safe-area-inset-right))",
        bottom: "calc(max(1.25rem, env(safe-area-inset-bottom)) + 64px)",
        boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
      }}
    >
      Start a Project
      <span aria-hidden>→</span>
    </a>
  );
};

export default StickyCTA;
